import api from "../../API/apiConfig";

//1. View Tasks Of Member
export const viewMemberTasks = async (type, id) => {
    try {
      const response = await api.get(`/tasks/${type}/${id}`);
      console.log("API Response:", response); 
      return response;
    } catch (error) {
      console.error("Error in viewMemberLogCall:", error);
      throw error;
    }
  };
  //2. Update Task
  export const updateTask = async (id, taskUpdateData) => {
    return await api.put(`tasks/update/${id}`, taskUpdateData);
  };
  //3. Delete Task
  export const deleteTask = async (id) => {
    return await api.delete(`tasks/delete/${id}`);
  };
  
  //4. Create Task
  export const createTask = async (taskData) => {
    return await api.post(`tasks/add`, taskData);
  }
  
  //5. Task Detail
  export const detailTask = async (id) => {
    return await api.get(`tasks/detail/${id}`);
  }
  //6. Get All Task
  export const getAllTasks = async () => {
    return await api.get(`tasks`);
  }